module.exports = __webpack_public_path__ + "static/img/WisdomSitePeople.1d1a8bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSitePeople.png
// module id = y3da
// module chunks = 12